module.exports = __webpack_public_path__ + "img/study02.108d9199.png";